import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export default function usePageTracking(userId?: string | null) {
  const location = useLocation();

  useEffect(() => {
    if (userId) {
      ReactGA.set({ user_id: userId});
    }

    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search,  user_id: userId });
  }, [location, userId]);
}
